(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["carrusel-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-carousel-block')) {
    customElements.define('video-carousel-block', class VideoCarouselBlock extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        this.viewport = this.querySelector('[data-vcb-viewport]');
        this.track = this.querySelector('[data-vcb-track]');
        this.navigation = this.querySelector('[data-vcb-navigation]');
        this.pagination = this.querySelector('[data-vcb-pagination]');
        this.status = this.querySelector('[data-vcb-status]');
        this.prevButton = this.querySelector('[data-vcb-prev]');
        this.nextButton = this.querySelector('[data-vcb-next]');
        this.activeIndex = 0;
        this.frame = null;
        this.rotateTimer = null;
        this.shouldLoop = this.dataset.loop === 'true';
        this.autoRotate = this.dataset.autoRotate === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rotateDelay = Math.max(3, Number(this.dataset.autoRotateSeconds) || 5) * 1000;

        if (!this.viewport || !this.track) return;

        const signal = this.controller.signal;
        this.addEventListener('click', this.handleClick.bind(this), { signal });
        this.viewport.addEventListener('keydown', this.handleKeydown.bind(this), { signal });
        this.viewport.addEventListener('scroll', this.handleScroll.bind(this), { passive: true, signal });
        this.addEventListener('mouseenter', () => window.clearTimeout(this.rotateTimer), { signal });
        this.addEventListener('mouseleave', () => this.resetAutoRotate(), { signal });
        this.addEventListener('focusin', () => window.clearTimeout(this.rotateTimer), { signal });
        this.addEventListener('focusout', () => this.resetAutoRotate(), { signal });
        window.addEventListener('resize', () => this.updateControls(), { passive: true, signal });
        document.addEventListener('visibilitychange', () => this.resetAutoRotate(), { signal });
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this), { signal });

        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this.track, { childList: true });
        this.refresh();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        window.clearTimeout(this.rotateTimer);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.controller = null;
      }

      refresh() {
        this.slides = Array.from(this.querySelectorAll('.vcb__slide'));
        this.slides.forEach((slide, index) => {
          slide.dataset.slideIndex = index;
          slide.setAttribute('aria-label', `${index + 1} de ${this.slides.length}`);
        });
        this.buildPagination();
        this.updateControls();
        this.resetAutoRotate();
      }

      buildPagination() {
        if (!this.pagination) return;
        this.pagination.replaceChildren();

        this.slides.forEach((slide, index) => {
          const page = document.createElement('button');
          page.type = 'button';
          page.className = 'vcb__page';
          page.dataset.vcbPage = index;
          page.setAttribute('aria-label', `Ir al video ${index + 1}`);
          if (index === 0) page.setAttribute('aria-current', 'true');

          if (this.dataset.paginationStyle === 'numbers') {
            page.textContent = index + 1;
          } else {
            const hiddenNumber = document.createElement('span');
            hiddenNumber.className = 'visually-hidden';
            hiddenNumber.textContent = index + 1;
            page.appendChild(hiddenNumber);
          }
          this.pagination.appendChild(page);
        });
      }

      hasOverflow() {
        return this.slides.length > 1 && this.viewport.scrollWidth > this.viewport.clientWidth + 2;
      }

      getNearestIndex() {
        if (!this.slides.length) return 0;
        const marker = this.viewport.scrollLeft + 2;
        return this.slides.reduce((best, slide, index) =>
          Math.abs(slide.offsetLeft - marker) < Math.abs(this.slides[best].offsetLeft - marker) ? index : best, 0);
      }

      updateControls() {
        if (!this.slides?.length) {
          if (this.navigation) this.navigation.hidden = true;
          if (this.status) this.status.textContent = '';
          return;
        }

        this.activeIndex = this.getNearestIndex();
        const overflow = this.hasOverflow();
        const atStart = this.viewport.scrollLeft <= 2;
        const atEnd = this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 2;

        if (this.navigation) this.navigation.hidden = !overflow;
        if (this.prevButton) this.prevButton.disabled = !overflow || (!this.shouldLoop && atStart);
        if (this.nextButton) this.nextButton.disabled = !overflow || (!this.shouldLoop && atEnd);

        this.querySelectorAll('[data-vcb-page]').forEach((page, index) => {
          if (index === this.activeIndex) page.setAttribute('aria-current', 'true');
          else page.removeAttribute('aria-current');
        });

        if (this.status) this.status.textContent = `Video ${this.activeIndex + 1} de ${this.slides.length}`;
      }

      goTo(requestedIndex, behavior = 'smooth') {
        if (!this.slides.length) return;
        let index = requestedIndex;
        if (this.shouldLoop) index = (index + this.slides.length) % this.slides.length;
        else index = Math.max(0, Math.min(index, this.slides.length - 1));

        this.viewport.scrollTo({ left: this.slides[index].offsetLeft, behavior });
        this.activeIndex = index;
      }

      handleClick(event) {
        const trigger = event.target.closest('[data-video-trigger]');
        if (trigger && this.contains(trigger)) {
          this.openPlayer(trigger);
          return;
        }

        if (event.target.closest('[data-vcb-prev]')) {
          const atStart = this.viewport.scrollLeft <= 2;
          this.goTo(this.shouldLoop && atStart ? this.slides.length - 1 : this.activeIndex - 1);
          this.resetAutoRotate();
          return;
        }

        if (event.target.closest('[data-vcb-next]')) {
          const atEnd = this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 2;
          this.goTo(this.shouldLoop && atEnd ? 0 : this.activeIndex + 1);
          this.resetAutoRotate();
          return;
        }

        const page = event.target.closest('[data-vcb-page]');
        if (page) {
          this.goTo(Number(page.dataset.vcbPage));
          this.resetAutoRotate();
        }
      }

      openPlayer(trigger) {
        this.pauseOtherPlayers();
        const media = trigger.closest('.vcb__media');
        const template = media?.querySelector('[data-video-template]');
        if (!media || !template) return;

        const fragment = template.content.cloneNode(true);
        trigger.remove();
        template.remove();
        media.appendChild(fragment);

        const video = media.querySelector('video');
        if (video) {
          video.muted = false;
          video.volume = 1;
          video.play().catch(() => {});
          video.addEventListener('ended', () => this.resetAutoRotate(), { once: true });
        }
        window.clearTimeout(this.rotateTimer);
      }

      pauseOtherPlayers() {
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.querySelectorAll('iframe[data-provider="youtube"]').forEach((iframe) => {
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
        });
        this.querySelectorAll('iframe[data-provider="vimeo"]').forEach((iframe) => {
          iframe.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
        });
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        this.resetAutoRotate();
      }

      handleScroll() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.updateControls();
          this.frame = null;
        });
      }

      handleBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const selected = event.target.closest('.vcb__slide');
        const index = this.slides.indexOf(selected);
        if (index >= 0) this.goTo(index, 'auto');
      }

      resetAutoRotate() {
        window.clearTimeout(this.rotateTimer);
        if (!this.autoRotate || !this.hasOverflow()) return;

        this.rotateTimer = window.setTimeout(() => {
          const nativeVideoPlaying = Array.from(this.querySelectorAll('video')).some((video) => !video.paused && !video.ended);
          const externalPlayerOpen = Boolean(this.querySelector('iframe.vcb__player'));
          const userIsInteracting = this.matches(':hover') || this.contains(document.activeElement) || document.hidden;

          if (!nativeVideoPlaying && !externalPlayerOpen && !userIsInteracting) {
            this.goTo(this.activeIndex === this.slides.length - 1 ? 0 : this.activeIndex + 1);
          }
          this.resetAutoRotate();
        }, this.rotateDelay);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
